(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pivot-responsive-video"] && !Shopify.designMode) return;
  try {
    class PivotResponsiveVideo extends HTMLElement {
    connectedCallback() {
      console.log('VIDEO RESPONSIVE');
      this.desktopVideo = this.querySelector('.pivot-desktop-video');
      this.mobileVideo = this.querySelector('.pivot-mobile-video');
      this.responsivePlay();
      window.addEventListener('resize', this.responsivePlay);
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.responsivePlay);
    }
    responsivePlay = () => {
      if (window.innerWidth > 750) {
        if (this.desktopVideo) this.desktopVideo.play();
        if (this.mobileVideo) this.mobileVideo.pause();
      } else {
        if (this.desktopVideo) this.desktopVideo.pause();
        if (this.mobileVideo) this.mobileVideo.play();
      }
    };
  }
  if (!customElements.get('pivot-responsive-video')) {
    customElements.define('pivot-responsive-video', PivotResponsiveVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pivot-slideshow-controls"] && !Shopify.designMode) return;
  try {
    class PivotCarouselControlsWrapper extends HTMLElement {
    connectedCallback() {
      if (!this.isConnected) return;
      this.slider = this.closest('slideshow-component');
      if (!this.slider) return;
      this.scroller = this.slider.querySelector('slideshow-slides');

      const columns   = parseInt(this.getAttribute('columns'))    || 1;
      const columnsMb = parseInt(this.getAttribute('columns-mb')) || 1;
      const totalPages   = parseInt(this.getAttribute('total-pages'))    || 1;
      const totalPagesMb = parseInt(this.getAttribute('total-pages-mb')) || 1;

      /**
       * Calcula el índice de página (0-based) para un slide dado.
       * Caso especial: si ya llegamos al final del scroll (última página parcial
       * con peek), el snap-scroll nunca llega al slide de esa página — detectamos
       * "al final" leyendo scrollLeft y forzamos el último dot.
       */
      const pageFor = (index, cols, total) => {
        if (total <= 1) return 0;
        const scrollEl = this.scroller;
        if (scrollEl) {
          const max = scrollEl.scrollWidth - scrollEl.clientWidth;
          if (max > 0 && scrollEl.scrollLeft >= max - 2) return total - 1;
        }
        return Math.max(0, Math.min(Math.floor(index / cols), total - 1));
      };

      const update = () => {
        const index = this.slider.current || 0;
        const pDk = pageFor(index, columns,   totalPages);
        const pMb = pageFor(index, columnsMb, totalPagesMb);

        this.querySelectorAll('.pvt-controls-dk button')
          .forEach((el, i) => el.setAttribute('aria-selected', String(i === pDk)));
        this.querySelectorAll('.pvt-controls-mb button')
          .forEach((el, i) => el.setAttribute('aria-selected', String(i === pMb)));

        const counter = this.querySelector('[ref="current"]');
        if (counter) counter.textContent = String(pDk + 1);
      };

      // Escucha el evento del slideshow (click en dot/flecha + scroll/drag)
      this.slider.addEventListener('slideshow:select', update);

      // Listener adicional de scroll: necesario para detectar "al final" cuando
      // el índice no cambia (misma página pero scrollLeft sigue aumentando hasta max)
      if (this.scroller) {
        let ticking = false;
        this.scroller.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => { update(); ticking = false; });
        }, { passive: true });
      }

      requestAnimationFrame(update);
    }
  }
  if (!customElements.get('pivot-carousel-controls-wrapper')) {
    customElements.define('pivot-carousel-controls-wrapper', PivotCarouselControlsWrapper);
  }
  } catch(e) { console.error(e); }
})();

})();
